import {
	ElementRef,
	Injectable,
	Renderer2,
	RendererStyleFlags2,
} from '@angular/core';

@Injectable()
export class ProfileSelectionViewProvider {
	private readonly GAP_PX = 56;
	private readonly PANEL_HEADER = 48;

	public adjustHeights(elemRef: ElementRef, renderer: Renderer2): void {
		const modalContent =
			elemRef.nativeElement.querySelector('.app-modal-content');

		const profileList = document.querySelector(
			'.app-profile-selection-modal .app-subscription-profile-list'
		) as HTMLElement | null;

		const profileListHeight =
			modalContent.offsetHeight - this.GAP_PX - this.PANEL_HEADER;

		renderer.setStyle(
			profileList,
			'--max-height-profiles',
			`${profileListHeight}px`,
			RendererStyleFlags2.DashCase
		);
	}
}
